import React from 'react'
import Grid from '@material-ui/core/Grid'

import Content from 'components/shared/Content'

interface IProps {
  sensor: any
}

const style = {
  borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
}

const Bulk = ({ sensor }: IProps) => (
  <Grid container direction="column">
    <Grid item>
      <Content style={style} label="Level" value={`${sensor.sensor1.toFixed(2)} mmwg`} />
    </Grid>
    <Grid item>
      <Content style={style} label="Pressure" value={`${sensor.sensor2.toFixed(2)} bar`} />
    </Grid>
  </Grid>
)

export default Bulk
